<template>
  <button
    class="uk-button uk-button-primary uk-flex uk-flex-middle"
    :class="size"
    v-if="vehicleId"
    @click.prevent="addToCart"
  >
    <span class="uk-margin-small-right uk-icon" uk-icon="icon: cart"></span>in den Warenkorb
  </button>
</template>
<script>
import CartService from '@/services/cart.service'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
export default {
  props: {
    vehicleId: {
      required: true
    },
    size: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      vehicleName: ''
    }
  },

  methods: {
    addToCart() {
      CartService.addToCart(this.vehicleId).then(response => {
        if (response.data.alreadyInCart) {
          iziToast.warning({
            title: 'Achtung!',
            message: response.data.message,
            timeout: 5000,
            position: 'topCenter'
          })
        } else {
          this.$store.dispatch('getCart')
          this.$store.dispatch('getCartCount')
          this.$emit('added', response.data)
        }
      })
    }
  }
}
</script>
